
import React, { Suspense, useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stars } from '@react-three/drei';
import * as THREE from 'three';
import '../styles/Home.css';

function City() {
  const count = 50;
  const positions = useMemo(() => {
    const pos = [];
    for (let i = 0; i < count; i++) {
      pos.push(Math.random() * 20 - 10, Math.random() * 5, Math.random() * 20 - 10);
    }
    return new Float32Array(pos);
  }, []);

  return (
    <instancedMesh args={[null, null, count]}>
      <boxGeometry args={[1, Math.random() * 5 + 1, 1]} />
      <meshStandardMaterial color="#8f00ff" />
      {positions && positions.map((p, i) => (
        <group key={i} position={[positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2]]}>
          <mesh>
            <boxGeometry args={[1, Math.random() * 10 + 1, 1]} />
            <meshStandardMaterial color="#8f00ff" emissive="#ff00ff" emissiveIntensity={0.5} />
          </mesh>
        </group>
      ))}
    </instancedMesh>
  );
}

function Hero() {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1 className="glitch" data-text="NACHO PEREIRA">NACHO PEREIRA</h1>
        <p>Visual Artist | DJ | AI Creator</p>
      </div>
      <Canvas className="hero-canvas" camera={{ position: [0, 5, 15], fov: 75 }}>
        <Suspense fallback={null}>
          <fog attach="fog" args={['#0a0a0a', 10, 30]} />
          <Stars />
          <ambientLight intensity={0.2} />
          <pointLight position={[10, 10, 10]} color="#00e5ff" intensity={1} />
          <pointLight position={[-10, -10, -10]} color="#ff00ff" intensity={1} />
          <City />
          <OrbitControls enableZoom={false} enablePan={false} autoRotate autoRotateSpeed={0.5} />
        </Suspense>
      </Canvas>
    </div>
  );
}

function Home() {
  return (
    <div className="home-container">
      <Hero />
      {/* Other sections will go here */}
    </div>
  );
}

export default Home;
